import { selectCalendar } from 'owa-calendar-surface-select-calendar';
import {
    createCalendar as createCalendarAction,
    setCalendarDisplayOrder,
} from 'owa-calendar-update';
import { createCalendar } from '../actions/calendarGroupActions';
import { orchestrator } from 'satcheljs';
import { isFeatureEnabled } from 'owa-feature-flags';

orchestrator(createCalendar, async actionMessage => {
    const { userIdentity, calendarName, calendarGroup, onCalendarCreated } = actionMessage;

    // Create and select a new calendar.
    const createdCalendar = await createCalendarAction(calendarName, calendarGroup, userIdentity);

    if (createdCalendar) {
        selectCalendar(createdCalendar);

        if (isFeatureEnabled('cal-calendarPickerReorder')) {
            setCalendarDisplayOrder(userIdentity, createdCalendar.calendarId.id);
        }
    }

    if (onCalendarCreated) {
        onCalendarCreated(createdCalendar);
    }
});
